<script lang="ts">
    const slots = $$slots;
</script>

<div class="gw-empty-state">
    {#if slots.icon}
        <div class="gw-empty-state__icon">
            <slot name="icon" />
        </div>
    {/if}

    {#if slots.title}
        <div class="gw-empty-state__title">
            <slot name="title" />
        </div>
    {/if}

    {#if slots.content}
        <div class="gw-empty-state__content">
            <slot name="content" />
        </div>
    {/if}

    {#if slots.footer}
        <div class="gw-empty-state__footer">
            <slot name="footer" />
        </div>
    {/if}
</div>

<style lang="postcss">
    .gw-empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 8px;
        padding: 30px;
    }
    .gw-empty-state__title {
        text-align: center;
    }
    .gw-empty-state__content {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
